import { render } from "./DialogIssueExternalCouponSuccess.vue?vue&type=template&id=490dda35&scoped=true"
import script from "./DialogIssueExternalCouponSuccess.vue?vue&type=script&lang=js"
export * from "./DialogIssueExternalCouponSuccess.vue?vue&type=script&lang=js"

import "./DialogIssueExternalCouponSuccess.vue?vue&type=style&index=0&id=490dda35&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-490dda35"

export default script